$ = require 'jquery'
AttachmentTypePickerView = require 'views/card/attachment-type-picker-view'
AutoMentionerView = require 'views/internal/autocomplete/auto-mentioner-view'
EmojiCompleterView = require 'views/internal/autocomplete/emoji-completer-view'
ModelLoader = require 'db/model-loader'
PopOver = require 'views/lib/pop-over'
TrelloCompleterView = require 'views/internal/autocomplete/trello-completer-view'
Util = require 'lib/util'
track = require 'debug/track'
Promise = require 'bluebird'

membersLastLoaded = {}

module.exports = class CompleterUtil

  openEmojiCompleter: (e) ->
    Util.stop(e)

    PopOver.pushView
      view: @getEmojiCompleterView("button")

  openAutoMentioner: (e) ->
    Util.stop(e)

    @getAutoMentionerView("button")
    .then (view) ->
      PopOver.pushView
        view: view

    track("Card Detail", "Mention Autocomplete", "Open Menu - With Click")

  autoMentionerView: (source) ->
    card = @getCard()
    new AutoMentionerView
      model: card
      button: source == 'button'
      input: source == 'input'
      target: @getTextInput()
      card: card
      selfMention: @selfMention
      modelCache: @modelCache

  getAutoMentionerView: (source) ->
    board = @getCard().getBoard()

    # Load the org members if we haven't done that recently
    if (org = board?.getOrganization())?
      if (!membersLastLoaded[org.id] || Date.now() - membersLastLoaded[org.id] > 5 * 60 * 1000)
        membersLastLoaded[org.id] = Date.now()
        ModelLoader.loadOrganizationMembersData org.id

    # Load board members if modelCache isn't properly populated
    if (@modelCache.get('Board', board.id).get('memberships').length != board.getIdBoardMems().length)
      return ModelLoader.loadBoardMembers board.id
        .then => @autoMentionerView(source)

    return Promise.resolve @autoMentionerView(source)

  getEmojiCompleterView: (source) ->
    card = @getCard()

    new EmojiCompleterView
      model: card
      button: source == 'button'
      input: source == 'input'
      target: @getTextInput()
      card: card
      modelCache: @modelCache

  getTrelloCompleterView: ->
    card = @getCard()

    new TrelloCompleterView
      model: card
      button: true
      target: @getTextInput()
      card: card
      modelCache: @modelCache

  commentAddAttachment: (e) ->
    Util.stop(e)

    $textInput = $(e.target).closest('.comment-box').find('textarea')
    selectionStart = $textInput.prop('selectionStart')
    selectionEnd = $textInput.prop('selectionEnd')
    selectedText = $textInput.val().substring(selectionStart, selectionEnd)

    card = @getCard()

    view = new AttachmentTypePickerView({ @model, @modelCache, defaultName: selectedText })

    view.on 'attach', ({ url, name }) ->
      name = name || selectedText

      replacement =
        if name
          "[#{ name }](#{ url })"
        else
          url
      Util.insertSelection($textInput, "#{ replacement } ", selectionStart, selectionEnd)
      $textInput.trigger('autosize.resize')

    PopOver.toggle
      elem: $(e.currentTarget)
      keepEdits: true
      view: view
      options: { model: card, @modelCache }

    track("Card Detail", "Comment Box - Open Attachment Type Picker")
    return

  commentMentionMember: (e) ->
    Util.stop(e)

    @getAutoMentionerView("button")
    .then (view) ->
      PopOver.toggle
        elem: $(e.currentTarget)
        keepEdits: true
        view: view

    track("Card Detail", "Comment Box - Mention Members")
    return

  commentAddEmoji: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.currentTarget)
      keepEdits: true
      view: @getEmojiCompleterView("button")

    track("Card Detail", "Comment Box - Add Emoji")
    return

  commentAddCard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.currentTarget)
      keepEdits: true
      view: @getTrelloCompleterView()

    track("Card Detail", "Comment Box - Add Card")
    return



// WEBPACK FOOTER //
// ./app/scripts/views/internal/autocomplete/completer-util.coffee